import { fromJS } from 'immutable'
import {
  EFFICIENCY_EDIT_REQUEST,
  EFFICIENCY_EDIT_SUCCESS,
  EFFICIENCY_EDIT_FAILURE,
  EFFICIENCY_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case EFFICIENCY_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case EFFICIENCY_EDIT_SUCCESS:
      return state
        .set('updatedEfficiencyResource', fromJS(action.payload.updatedEfficiencyResource))
        .set('status', 200)
        .set('isFetching', false)
    case EFFICIENCY_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case EFFICIENCY_EDIT_RESET:
      return state
        .delete('updatedEfficiencyResource')
        .delete('status')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/efficiency-resource/efficiency-edit-reducer.js